import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useScrollAnimations = (deps: unknown[] = []) => {
  const { pathname } = useLocation();

  useEffect(() => {
    const elements = document.querySelectorAll(".animate");

    if (!elements.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
          }
        });
      },
      {
        threshold: 0.2,
        rootMargin: "0px 0px -100px 0px"
      }
    );

    elements.forEach((element) => observer.observe(element));

    return () => observer.disconnect();
  }, [pathname, ...deps]);
};
